import { WIR } from 'types/wellGuardian';

import { getAllSections } from './getAllSections';
import { getReactiveStepKeys, getStepKeys } from './getStepKeys';

export const getNonReactiveSections = (wir: WIR | null, country: string) => {
  return getAllSections(wir, country).filter(x => getStepKeys(country).indexOf(x.phase) !== -1);
};

export const getReactiveSections = (wir: WIR | null, country: string) => {
  return getAllSections(wir, country).filter(
    x => getReactiveStepKeys(country).indexOf(x.phase) !== -1,
  );
};
